<template>
  <modal
    title="Deactivate Wallet"
    width="35"
    :showModal="showModal"
    @close-modal="$emit('closeModal')"
  >
    <div>
      <b class="mt-3 block"
        >Are you sure you want to deactivate this Wallet Account?</b
      >
      <p class="py-2">
        *Note: You will not be able to make payments for your healthcare
        services with this Account once deactivated.
      </p>
      <div class="mt-8 flex justify-end">
        <button class="mr-3" @click="$emit('closeModal')">cancel</button>
        <button
          class="py-2 px-2 bg-primary-yellow rounded-md"
          @click="deactivateWallet"
        >
          Confirm
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      currencies: ["NGN"],
      wallet: {
        currency: "NGN",
      },
    };
  },
  methods: {
    async deactivateWallet() {
      await this.$_deactivateWallet()
      this.$emit("reset")
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped lang="scss">
.input {
  @apply w-12 h-12 text-primary-black border-2 border-gray-300 flex text-center items-center rounded-md mx-2;
}
.el-select {
  margin-bottom: 0;
}
.border_1 {
  border-width: 1px;
}
</style>
